/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ "+": NonNullable<unknown> }} Matching_Score_Algorithm_Missing_Required_Tech_SkillInputs */

const en_matching_score_algorithm_missing_required_tech_skill = /** @type {(inputs: Matching_Score_Algorithm_Missing_Required_Tech_SkillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Missing required tech skills: ${i?.["+"]}`)
};

const de_matching_score_algorithm_missing_required_tech_skill = /** @type {(inputs: Matching_Score_Algorithm_Missing_Required_Tech_SkillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlende erforderliche Tech-Skills: ${i?.["+"]}`)
};

/**
* | output |
* | --- |
* | "Missing required tech skills: {+}" |
*
* @param {Matching_Score_Algorithm_Missing_Required_Tech_SkillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_algorithm_missing_required_tech_skill = /** @type {((inputs: Matching_Score_Algorithm_Missing_Required_Tech_SkillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Algorithm_Missing_Required_Tech_SkillInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_algorithm_missing_required_tech_skill(inputs)
	return en_matching_score_algorithm_missing_required_tech_skill(inputs)
});